import { useState } from "react";

import Api from "../Services/Api";

function useProvideAuth() {
	const [oxygenUser, setUser] = useState(localStorage.getItem('oxygenUser') ? JSON.parse(localStorage.getItem('oxygenUser')) : null);

	async function signin(loginPayload) {
		try {
			localStorage.setItem('token', null);
			localStorage.setItem('oxygenUser', null);
			return Api.post({endpoint: 'login', body: loginPayload, contentType : 'application/json'})
				.then(response => {
					const token = response.data.token;
					if(token){
						localStorage.setItem('token', token);
						localStorage.setItem('oxygenUser', JSON.stringify(response.data.oxygenUser));
						setUser(response.data.oxygenUser);
					}
					return {'status': response.status, 'role' : response.data.oxygenUser.roles[0].name};
				})
				.catch(error => {
					console.log(error);
					setUser(null);
					return {
						'status': error.response ? error.response.status : null,
						'error': (error.response && error.response.data)? error.response.data.error : null,
					};
				});
		} catch (error) {
			console.log(error);
			setUser(null);
			return {'status': error.response ? error.response.status : null};
		}
	};

	async function tokenSignin(token) {
		try {
			localStorage.setItem('token', null);
			localStorage.setItem('oxygenUser', null);
			return Api.post({endpoint: 'login_token', body: { 'token': token }, contentType : 'application/json'})
				.then(response => {
					const token = response.data.token;
					if(token){
						localStorage.setItem('token', token);
						localStorage.setItem('oxygenUser', JSON.stringify(response.data.oxygenUser));
						setUser(response.data.oxygenUser);
					}
					return {'status': response.status, 'role' : response.data.oxygenUser.roles[0].name};
				})
				.catch(error => {
					console.log(error);
					setUser(null);
					return {
						'status': error.response ? error.response.status : null,
						'error': (error.response && error.response.data)? error.response.data.error : null,
					};
				});
		} catch (error) {
			console.log(error);
			setUser(null);
			return {'status': error.response ? error.response.status : null};
		}
	};

	function signout() {
		try {
			Api.get({endpoint: 'logout', contentType : 'application/json'})
				.then(response => {
					unsetUser();
					return response.status;
				})
				.catch(error => {
					console.log(error);
					unsetUser();
					return (error.response ? error.response.status : null);
				});
		} catch (error) {
			console.log(error);
			unsetUser();
			return (error.response ? error.response.status : null);
		}
	};

	function unsetUser() {
		localStorage.removeItem('token');
		localStorage.removeItem('oxygenUser');
		setUser(null);
	}

	return {
		oxygenUser,
		signin,
        tokenSignin,
		signout,
	};
}

export default useProvideAuth;